import React from "react";
import { Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Swal from "sweetalert2";

const FarPaymentDisplay = ({ paymentDetails, totalAmount }) => {
  const { t } = useTranslation();
  const Modal = useModal();
  console.log("paymentDetails", paymentDetails);
  const details = paymentDetails?.FeeInstallment?.[0];
  const isFullPayment = paymentDetails?.FeeInstallment?.length > 1;
  const installments = paymentDetails?.FeeInstallment;
  console.log("fromDisplay", installments, isFullPayment);

  const installmentBreakdown = `<ul class="installment-breakdown">
  <li><strong>Total Amount of Purchasable FAR:</strong> ${totalAmount}</li>
  <li><strong>First installment to be paid at the time of provisional approval (25% of Total Amount):</strong> ${installments?.[0]?.amount}</li>
  <li><strong>Interest on remaining amount:</strong> 12% yearly on remaining balance</li>
  <li><strong>Interest calculated on remaining amount:</strong> {Interest Amount} added to subsequent installments</li>
  <li><strong>Subsequent Installments:</strong> {Installment Amount} + {Interest Amount}</li>
  <li><strong>Penalty for late installment payments:</strong> 3% penalty on the installment amount if payment is delayed</li>
</ul>`;
  const handleClick = () => {
    Swal.fire({
      title: "Installments Breadkdown",
      html: installmentBreakdown,
      icon: null,
      backdrop: true,
      allowOutsideClick: false,
      customClass: {
        popup: "info-modal", // Custom class for the modal
        title: "info-modal-title", // Custom class for the title
        content: "info-modal-content", // Custom class for the content
      },
    });
  };
  return isFullPayment ? (
    <Table bordered>
      <thead className="table-header">
        <tr>
          <th style={{ width: "50%" }}>
            {t("Installment Breakdown")}
            <span className="info-icon" onClick={handleClick}>
              <InfoOutlinedIcon />
            </span>
          </th>
          <th style={{ width: "20%" }}>{t("Amount")}</th>
          <th style={{ width: "30%" }}>{t("Due Date")}</th>
        </tr>
      </thead>
      {installments.map((item) => (
        <tbody key={item.id}>
          <tr rowSpan={2}>
            <td>
              <b>{item.installmentNumber === 1 ? "25% of total amount" : `Installment ${item.installmentNumber - 1}`}</b>
            </td>
            <td>{`₹ ${item?.amount}`}</td>
            <td>{item?.dueDate}</td>
          </tr>
        </tbody>
      ))}
    </Table>
  ) : (
    <Table bordered className="m-0">
      <thead className="table-header">
        <tr>
          <th style={{ minWidth: "fit-content" }}>Field Name</th>
          <th style={{ minWidth: "fit-content" }}>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>{t("Total Amount")}</b>
          </td>
          <td>{`₹ ${details?.amount}`}</td>
        </tr>
      </tbody>
      {/* {!Boolean(formData?.taxHeadEstimates?.[0]?.estimateAmount) && (
      <span style={{ margin: "18px auto", padding: "4px" }}>Fees will be generated only after application is approved.</span>
    )} */}
    </Table>
  );
};

export default FarPaymentDisplay;
